import React from 'react';
import { Slide, SlideProps, Snackbar, Typography } from '@mui/material';
import { snackbar } from './CustomSnackbar.sx';
import SnackbarInfo from 'app/components/Icons/SnackbarInfo';
import SnackbarError from 'app/components/Icons/SnackbarError';
import SnackbarWarning from 'app/components/Icons/SnackbarWarning';
import SnackbarSuccess from 'app/components/Icons/SnackbarSuccess';
import logger from 'app/utils/logger';

interface Props {
  open: any;
  setOpen: any;
  hideDuration: any;
  type: any;
  text: any;
}

const TransitionSlide = (props: SlideProps) => {
  return <Slide {...props} direction={'left'} />;
};

const CustomSnackbar = (props: Props) => {
  const { open, setOpen, text, hideDuration, type } = props;

  logger.log(type);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={hideDuration}
      onClose={() => setOpen(false)}
      TransitionComponent={TransitionSlide}
      ContentProps={{ sx: snackbar(type) }}
      message={
        <Typography>
          {type === 'info' ? (
            <SnackbarInfo />
          ) : type === 'error' || type === 'error_inline' || type === undefined ? (
            <SnackbarError />
          ) : type === 'warning' ? (
            <SnackbarWarning />
          ) : (
            type === 'success' && <SnackbarSuccess />
          )}
          {text}
        </Typography>
      }
    />
  );
};

export default CustomSnackbar;
